import { useEffect } from 'react';
import './UploadProgress.less';
import loading from '@/assets/loading.gif';
import { ConfigProvider, Progress } from 'antd';
export default function UploadProgress(props) {
  useEffect(() => {}, []);
  return (
    <div className="upload-progress">
      <img className="upload-loading" src={loading}></img>
      <span className="upload-progress-title">{props.title || 'Loading'}</span>
      <ConfigProvider
        theme={{
          components: {
            Progress: {
              defaultColor: '#A0F00F',
              remainingColor: '#313131',
            },
          },
        }}>
        <Progress style={{ width: 300 }} showInfo={false} percent={props.percent}></Progress>
      </ConfigProvider>
    </div>
  );
}
